import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './sidebar';
import GlobalLoadingBar from './GlobalLoadingBar';
import useScrollbarStyles from '../../hooks/useScrollbarStyles';
import { useInactivityLogout } from '../../hooks/useInactivityLogout';

const Layout = ({ children }: { children: React.ReactNode }) => {
    useScrollbarStyles();
    useInactivityLogout();
    const location = useLocation();
    const isCatalogRoute = location.pathname.startsWith("/catalog");
    const isDashboardRoute = location.pathname === "/" || location.pathname.startsWith("/dashboard");

    return (
        <div className="h-screen overflow-hidden flex">
            <Sidebar />
            <main className={`relative main flex-1 min-h-0 min-w-0 overflow-y-auto`}>
                <GlobalLoadingBar />
                {/* Use padding instead of margins so the dashboard can keep a true 100vh content box. */}
                {children}
            </main>
        </div>
    );
};

export default Layout;
